import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
  Edit,
} from "@syncfusion/ej2-react-grids";
import { Modal } from "antd";
import { useBarcodeStore } from "../../../store/useBarcodeMasterStore";
import { updateAgingStoreApi } from "../../../services/barCodeMaster";

const BasicGrid = ({ onRefresh }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [gridData, setGridData] = useState([]);
  const [editingRowId, setEditingRowId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const { agingList, getAgingList } = useBarcodeStore();
  useEffect(() => {
    if (agingList?.length) {
      const formattedData = agingList.map((item, index) => ({
        ...item,
        serialNo: index + 1,

        PopulatedDate: item.PopulatedDate ? new Date(item.PopulatedDate) : null,

        ManufactureDate: item.ManufactureDate
          ? new Date(item.ManufactureDate)
          : null,

        UploadedOn: item.UploadedOn ? new Date(item.UploadedOn) : null,
      }));

      setGridData(formattedData);
    }else{
      setGridData([])
    }
  }, [agingList]);

  const updatedMrpTemplate = (props) => {
    const [localValue, setLocalValue] = useState(props.UpdatedMrp ?? "");
    useEffect(() => {
      setLocalValue(props.UpdatedMrp ?? "");
    }, [props.UpdatedMrp]);
    const isEditing = editingRowId === props.Id;

    if (!isEditing) {
      return <span>{props.UpdatedMrp}</span>;
    }
    const handleChange = (e) => {
      const value = Math.max(0, Number(e.target.value || 0));
      setLocalValue(value);
      if (value < props.Mrp) {
        setModalMsg("Updated MRP value cannot be less than previous MRP value");
        setIsModalOpen(true);
        return;
      }
    };
    const handleBlur = (e) => {
      const value = Math.max(0, Number(e.target.value || 0));
      setGridData((prev) =>
        prev.map((row) =>
          row.Id === props.Id ? { ...row, UpdatedMrp: value } : row,
        ),
      );
    };

    return (
      <input
        type="number"
        min={0}
        value={localValue}
        onChange={handleChange}
        onBlur={handleBlur}
        style={{
          width: "80px",
          padding: "4px",
          textAlign: "center",
        }}
      />
    );
  };

  const updatedSOHTemplate = (props) => {
    const [localValue, setLocalValue] = useState(props.UpdatedSOH ?? "");
    useEffect(() => {
      setLocalValue(props.UpdatedSOH ?? "");
    }, [props.UpdatedSOH]);
    const isEditing = editingRowId === props.Id;

    if (!isEditing) {
      return <span>{props.UpdatedSOH}</span>;
    }
    const handleChange = (e) => {
      const value = Math.max(0, Number(e.target.value || 0));

      if (value > props.SOH) {
        setModalMsg(
          "Updated SOH value cannot be greater than previous SOH value",
        );
        setIsModalOpen(true);
        return;
      }
      setLocalValue(value);
    };

    const handleBlur = (e) => {
      const value = Math.max(0, Number(e.target.value || 0));
      setGridData((prev) =>
        prev.map((row) =>
          row.Id === props.Id ? { ...row, UpdatedSOH: value } : row,
        ),
      );
    };

    return (
      <input
        type="number"
        min={0}
        value={localValue}
        onChange={handleChange}
        onBlur={handleBlur}
        style={{
          width: "80px",
          padding: "4px",
          textAlign: "center",
        }}
      />
    );
  };

  const actionTemplate = (props) => {
    const isEditing = editingRowId === props.Id;

    const handleEditClick = (e) => {
      e.stopPropagation();
      setGridData((prev) =>
        prev.map((row) =>
          row.Id === props.Id
            ? {
                ...row,
                UpdatedSOH: row.UpdatedSOH === 0 ? row.SOH : row.UpdatedSOH,
                UpdatedMrp: row.UpdatedMrp === 0 ? row.Mrp : row.UpdatedMrp,
              }
            : row,
        ),
      );
      setEditingRowId(props.Id);
    };

    const handleCheckboxClick = async (e) => {
      e.stopPropagation();
      const payload = [
        {
          populatedDate: onRefresh?.date,
          loc: props.StoreCode,
          itemCode: props.ItemCode,
          grnBucket: props.GrnBucket,
          soh: props.SOH,
          updatedSOH: props.UpdatedSOH,
          totalSOH: props.Total_SOH,
          manufactureDate: props.ManufactureDate,
          mrp: props.Mrp,
          updatedMrp: props.UpdatedMrp,
          discount: props.DiscountPer,
        },
      ];
      console.log("Payload on Save:", payload);
      try {
        await updateAgingStoreApi(payload);
        await getAgingList(onRefresh);
      } catch (error) {}

      setEditingRowId(null);
    };

    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        {!isEditing ? (
          <button
            onClick={handleEditClick}
            title="Edit"
            className="e-btn e-flat"
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            <span className="e-icons e-edit" style={{ fontSize: "16px" }} />
          </button>
        ) : (
          <button
            onClick={handleCheckboxClick}
            title="Save"
            className="e-btn e-flat"
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            <span
              className="e-icons e-check"
              style={{ fontSize: "16px", color: "green" }}
            />
          </button>
        )}
      </div>
    );
  };

  let gridInstance;

  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "BrokerGrid_excelexport") {
      gridInstance.excelExport();
    }
  };

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            <GridComponent
              ref={(g) => (gridInstance = g)}
              id="BrokerGrid"
              dataSource={gridData}
              allowPaging={true}
              allowSorting={true}
              allowFiltering={true}
              filterSettings={{ type: "Excel" }}
              toolbar={["ExcelExport", "Search"]}
              allowExcelExport={true}
              toolbarClick={toolbarClick}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              gridLines="Both"
              height={"300px"}
              pageSettings={{
                pageSizes: [10, 20, 30, 40, 50, "All"],
                pageCount: 10,
              }}
              rowHeight={isMobile ? "" : 32}
              allowResizing={true}
              dataBound={() => {
                if (!isMobile && gridInstance) {
                  gridInstance.autoFitColumns();
                }
              }}
              // frozenColumns={1}

              // rowDataBound={()}
              // commandClick={handleCommandClick}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="serialNo"
                  headerText="S No"
                  width="90"
                  textAlign="Center"
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="Id"
                  headerText="Id"
                  width="90"
                  textAlign="Center"
                  visible={false}
                />
                <ColumnDirective
                  field="PopulatedDate"
                  headerText="Populated Date"
                  width="180"
                  type="date"
                  format="dd/MM/yyyy"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="StoreCode"
                  headerText="Store Code"
                  width="180"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="StoreName"
                  headerText="Store Name"
                  width="250"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="ItemCode"
                  headerText="Item Code"
                  width="200"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="ShortDesc"
                  headerText="Short Desc"
                  width="250"
                  textAlign="Left"
                  allowEditing={false}
                />

                <ColumnDirective
                  field="DivisionName"
                  headerText="Division Name"
                  width="180"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="GrnBucket"
                  headerText="Grn Bucket"
                  width="180"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="SOH"
                  headerText="SOH"
                  width="150"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="UpdatedSOH"
                  headerText="UPDATED SOH"
                  width="180"
                  template={updatedSOHTemplate}
                />
                <ColumnDirective
                  field="Total_SOH"
                  headerText="Total SOH"
                  width="150"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="ManufactureDate"
                  headerText="Manufacture Date"
                  width="250"
                  type="date"
                  format="dd/MM/yyyy"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="DiscountPer"
                  headerText="Discount Per"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Mrp"
                  headerText="MRP"
                  width="150"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="UpdatedMrp"
                  headerText="UPDATED MRP"
                  width="180"
                  template={updatedMrpTemplate}
                />

                <ColumnDirective
                  field="UploadedOn"
                  headerText="Uploaded On"
                  width="180"
                  textAlign="Left"
                  type="date"
                  format="dd/MM/yyyy"
                />
                <ColumnDirective
                  field="Updated"
                  headerText="Updated"
                  width="200"
                  template={(props) => (
                    <span
                      style={{
                        fontWeight: 600,
                        color:
                          props.Updated === "Pending" ? "#f39c12" : "#28a745",
                      }}
                    >
                      {props.Updated}
                    </span>
                  )}
                />
                <ColumnDirective
                  field="Approved"
                  headerText="Approved"
                  width="200"
                  template={(props) => (
                    <span
                      style={{
                        fontWeight: 600,
                        color:
                          props.Approved === "Pending" ? "#f39c12" : "#28a745",
                      }}
                    >
                      {props.Approved}
                    </span>
                  )}
                />

                <ColumnDirective
                  field="Action"
                  headerText="Action"
                  width="150"
                  textAlign="Left"
                  template={actionTemplate}
                />
              </ColumnsDirective>

              <Inject
                services={[
                  Edit,
                  CommandColumn,
                  Page,
                  Filter,
                  Toolbar,
                  ExcelExport,
                  Sort,
                  Group,
                  Resize,
                  Freeze,
                ]}
              />
            </GridComponent>
          </Col>
        </Row>
      </div>

      <Modal
        open={isModalOpen}
        footer={[
          <div
            key="ok-btn"
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <button
              onClick={() => setIsModalOpen(false)}
              style={{
                padding: "8px 28px",
                backgroundColor: "#1677ff",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>,
        ]}
        closable={false} // ❌ remove top-right X
        centered
      >
        <p
          style={{
            fontSize: "25px", // text bada
            color: "#333",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          {modalMsg}
        </p>
      </Modal>
    </>
  );
};

export default BasicGrid;
